<h1>
  <ng-content></ng-content>
  <span *ngIf="pageTooltip" [ngbTooltip]="pageTooltip" placement="right" class="ml-2">
    <svg class="bg-light icon icon-sm">
      <use href="assets/icons/bootstrap-italia-icons.svg#it-help-circle"></use>
    </svg>
  </span>
</h1>
